import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { DeviceType } from '@/Module/Core/Model/Enum';
import { coreInitialedAction } from '@/Module/Core/Store/Action';

const CoreSlice = createSlice({
  name: 'core',
  initialState: {
    initialed: false,
    deviceType: DeviceType.MOBILE,
  },
  reducers: {
    setDeviceType: (state, { payload }: PayloadAction<DeviceType>) => {
      state.deviceType = payload;
    },
  },

  extraReducers: builder => {
    builder.addCase(coreInitialedAction, state => {
      state.initialed = true;
    });
  },
});

export const { setDeviceType: coreSetDeviceTypeAction } = CoreSlice.actions;

export default CoreSlice;
